export const SETTLEMENT_FILTER_KEYS = {
  CREATED_BY: 'Creado Por',
  STATUS: 'Estado'
}

export const SETTLEMENT_APPROVAL_STATUS = {
  SENT: 'sent',
  RECEIVED: 'received',
  PENDING: 'document_pending',
  INSERTED_ERP: 'inserted_erp'
}

export const SETTLEMENT_APPROVAL_STATUS_UI = {
  [SETTLEMENT_APPROVAL_STATUS.PENDING]: {
    label: 'PENDIENTE',
    variant: 'warning',
    className: 'oc-pending-style'
  },
  [SETTLEMENT_APPROVAL_STATUS.RECEIVED]: {
    label: 'RECIBIDO',
    variant: 'success',
    className: 'received-style'
  },
  [SETTLEMENT_APPROVAL_STATUS.SENT]: {
    label: 'ENVIADO',
    variant: 'settlement-sent',
    className: 'settlement-sent-style'
  },
  [SETTLEMENT_APPROVAL_STATUS.INSERTED_ERP]: {
    label: 'INSERTADO',
    variant: 'success',
    className: 'inserted-style'
  }
}

export const SETTLEMENT_STATUS_FILTER_OPTIONS = Object.values(
  SETTLEMENT_APPROVAL_STATUS_UI
).map(({ label }) => label)

export const getSettlementStatusUI = (status) => {
  return (
    SETTLEMENT_APPROVAL_STATUS_UI[status] || {
      label: '',
      className: ''
    }
  )
}

export const buildSettlementLabelMapping = (settlements = [], shouldShowStatusFilter = false) => {
  const labelToIdMapping = {}

  const createdByOptions = settlements
    .map((settlement) => {
      const label = `${settlement.user_uid} - ${settlement.user_full_name}`
      labelToIdMapping[label] = settlement.user_uid
      return label
    })
    .filter((value, index, self) => self.indexOf(value) === index)

  const filters = [{ key: SETTLEMENT_FILTER_KEYS.CREATED_BY, value: createdByOptions }]

  if (shouldShowStatusFilter) {
    SETTLEMENT_STATUS_FILTER_OPTIONS.forEach((label) => {
      const statusEntry = Object.entries(SETTLEMENT_APPROVAL_STATUS_UI).find(
        ([, value]) => value.label === label
      )

      if (statusEntry) {
        labelToIdMapping[label] = statusEntry[0]
      }
    })

    filters.push({ key: SETTLEMENT_FILTER_KEYS.STATUS, value: SETTLEMENT_STATUS_FILTER_OPTIONS })
  }

  return { filters, labelToIdMapping }
}

export const buildSettlementsFilterQuery = (allSelectedOptions = new Map()) => {
  const createdBy = allSelectedOptions.get(SETTLEMENT_FILTER_KEYS.CREATED_BY) || []
  const statuses = allSelectedOptions.get(SETTLEMENT_FILTER_KEYS.STATUS) || []
  const queryParts = []

  if (createdBy.length > 0) {
    queryParts.push(`client_uid=${encodeURIComponent(createdBy.join(','))}`)
  }

  if (statuses.length > 0) {
    queryParts.push(`status=${encodeURIComponent(statuses.join(','))}`)
  }

  return queryParts.length > 0 ? `&${queryParts.join('&')}` : ''
}

export const updateSettlementSelectedOptions = ({
  currentOptions = new Map(),
  identifier,
  selectedOptions = [],
  labelToIdMapping = {}
}) => {
  const nextOptions = new Map(currentOptions)
  const selectedValues = selectedOptions.map((option) => labelToIdMapping[option] || option)

  if (selectedValues.length > 0) {
    nextOptions.set(identifier, selectedValues)
  } else {
    nextOptions.delete(identifier)
  }

  return nextOptions
}

export const buildSettlementsIndexQueryString = ({
  currentPage,
  perPage,
  filterQuery,
  dateQuery,
  query,
  businessTenantUid
}) => {
  const hasFilters = Boolean(filterQuery || dateQuery)

  return `${currentPage ? `page=${currentPage}` : ''}&per_page=${perPage}${
    hasFilters ? '&filter_search=true' : ''
  }${filterQuery || ''}${dateQuery || ''}${query ? `&q=${encodeURIComponent(query)}` : ''}&business_tenant_uid=${businessTenantUid}`
}
